import { Stack } from "@mui/material";
import { type ReactNode } from "react";

import { HeaderMenuButton } from "./HeaderMenuButton";

export interface HeaderMenuButtonRowProps {
  children: ReactNode;
}

/**
 * A header row that places the mobile {@link HeaderMenuButton} to the left of its
 * content (typically a page title). The button self-gates to mobile + flag, so on
 * desktop or when the flag is off this renders just the content.
 */
export function HeaderMenuButtonRow({ children }: HeaderMenuButtonRowProps) {
  return (
    <Stack direction="row" spacing={2} sx={{ alignItems: "center", minWidth: 0 }}>
      <HeaderMenuButton />
      {children}
    </Stack>
  );
}
